<template>
  <div>
    <AddRetainershipModal :company="company"></AddRetainershipModal>
    <AddNewRetainershipModal :company="company"></AddNewRetainershipModal>
    <!-- <ApprovalRequestModal></ApprovalRequestModal> -->
    <!-- <AssignCardModal></AssignCardModal> -->
    <MasterLayout>
      <!-- LOADER -->
      <section class="row card-loader-wrapper w-100" v-if="showLoader">
        <div
          class="col-md-3 position-relative mb-2"
          v-for="(c, i) in 4"
          :key="i"
        >
          <div class="card-loader"></div>
        </div>
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full mt-5 rounded-lg w-full"
          style="width: 130% !important; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->
      </section>
      <!-- END LOADER -->

      <section v-if="!showLoader">
        <section>
          <h5>{{ $t("text.retainership.cardRequest") }}</h5>
          <div class="fuelbalance_first_row">
            <div class="row w-100">
              <div class="col-sm-12 col-lg-3">
                <div
                  style="background-color: #46266e; color: white"
                  class="d-flex justify-content-between overview-card p-4 px-10"
                >
                  <div class="">
                    <h5>{{ $t("text.retainership.totalCards") }}</h5>
                    <p class="mt-3">{{ totalCards }}</p>
                  </div>
                </div>
              </div>

              <div
                v-for="(card, index) in cards"
                :key="index"
                class="col-sm-12 col-lg-3 cursor-pointer"
              >
                <div
                  @click="
                    () =>
                      card.title.toLowerCase() !== 'available cards' &&
                      changeTable(card.title)
                  "
                  class="d-flex justify-content-between overview-card p-4 px-10 shadow-sm"
                >
                  <div class="">
                    <h5>{{ card.title }}</h5>

                    <p
                      class="mt-3"
                      v-if="card.title.toLowerCase() == 'available cards'"
                    >
                      {{ availableCards }}
                    </p>

                    <p
                      class="mt-3"
                      v-if="card.title.toLowerCase() == 'pending requests'"
                    >
                      {{ pendingRequestNumber }} <small>(requests)</small> /
                      {{ pendingNumberOfCardRequest }}
                      <small>(cards)</small>
                    </p>

                    <p
                      class="mt-3"
                      v-if="card.title.toLowerCase() == 'approved requests'"
                    >
                      {{ approvedRequestNumber }} <small>(requests)</small> /
                      {{ approvedNumberOfCardRequest }} <small>(cards)</small>
                    </p>
                  </div>

                  <div>
                    <img
                      :src="require(`@/assets/svg/${card.image}`)"
                      alt="Card Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section
            class="d-flex justify-content-between align-items-center mr-4"
          >
            <div>
              <h3 style="font-size: 20px" class="ml-2 mt-2">{{ tableType }}</h3>
            </div>
            <div v-if="availableCards && availableCards > 0">
              <router-link
                :to="{
                  name: 'approve-retainership-card-request',
                  query: { assign: true, companyId: companyId },
                }"
              >
                <button
                  class="py-2 px-3 text-white"
                  style="
                    background-color: #46266e;
                    border: none;
                    border-radius: 5px;
                    font-size: 14px;
                  "
                  @click="showAssignCardModal"
                >
                  {{ $t("text.retainership.assignCard") }}
                </button>
              </router-link>
            </div>
          </section>
        </section>

        <section class="section__row mt-3">
          <div class="" v-if="tableType.toLowerCase() == 'pending requests'">
            <PendingRequest
              :pendingRequest="pendingRequest"
              :showLoader="showLoader"
              :usedLang="usedLang"
            />
          </div>

          <!-- approved table -->
          <div class="" v-if="tableType.toLowerCase() == 'approved requests'">
            <ApprovedRequest
              :approvedRequest="approvedRequest"
              :showLoader="showLoader"
              :usedLang="usedLang"
            />
          </div>
          <!--  -->

          <!-- declined table -->
          <div class="" v-if="tableType.toLowerCase() == 'declined requests'">
            <DeclinedRequest
              :approvedRequest="declinedRequest"
              :showLoader="showLoader"
              :usedLang="usedLang"
            />
          </div>
          <!--  -->
        </section>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import AssignCardModal from "@/components/modals/Remis/Retainership/CardRequest/assignCard";
import ApprovalRequestModal from "@/components/modals/Remis/Retainership/CardRequest/approveCardRequest";
import AddRetainershipModal from "@/components/modals/addRetainershipModal";
import AddNewRetainershipModal from "@/components/modals/addNewRetainershipModal";
import DropDown from "@/components/Templates/Dropdown/companyRetainershipDropdown.vue";
import RetTemp from "@/components/Templates/companyRetainershipTemplate.vue";

import ActionTemp from "@/components/TableTemplates/retainership/cardRequest.vue";

//component
import PendingRequest from "@/BreakdownComponent/Company/Remis/CardRequest/PendingRequest.vue";
import ApprovedRequest from "@/BreakdownComponent/Company/Remis/CardRequest/ApprovedRequest.vue";
import DeclinedRequest from "@/BreakdownComponent/Company/Remis/CardRequest/DeclinedRequest.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Retainership :: Epump Portal",
  name: "Retainership",
  components: {
    MasterLayout,
    ApprovalRequestModal,
    AddRetainershipModal,
    AddNewRetainershipModal,

    TableLoader,
    DropDown,
    AssignCardModal,

    PendingRequest,
    ApprovedRequest,
    DeclinedRequest,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      approvedNumberOfCardRequest: 0,
      pendingNumberOfCardRequest: 0,
      totalCards: 0,
      secondTableData: [],
      tableType: "Pending requests",
      pendingRequest: [],
      approvedRequest: [],
      declinedRequest: [],
      availableCards: 0,
      pendingRequestNumber: 0,
      approvedRequestNumber: 0,
      declinedRequestNumber: 0,
      cards: [
        {
          title: "Available Cards",
          number: this.availableCards,
          image: "wallet.svg",
        },
        {
          title: "Pending Requests",
          number: this.pendingRequestNumber,
          image: "Pending.svg",
        },

        {
          title: "Approved Requests",
          number: this.approvedRequestNumber,
          image: "aproved.svg",
        },
      ],
      usedLang: this.$store.getters.getLanguage,
      pendingRequest: 0,
      showLoader: false,
      totalTransactions: null,
      tableDataCount: 10,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      company: null,
      companyId: this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company
        ? this.company.id
        : "",
      details: {
        data: { status: "" },
        queryStrings: { id: "", companyId: this.$route.query.companyId },
        info: [
          {
            name: this.$t("text.assets.updateCreditLimit"),
            emitName: "updateCreditLimit",
          },
          {
            name: this.$t("text.assets.walletTransactions"),
            emitName: "walletTransactions",
          },
        ],
        delete: {
          hasDelete: false,
          deleteName: "deleteInvoice",
          name: "Delete",
          query: "id",
        },
      },
      optionsTemplate: function () {
        return {
          template: RetTemp,
        };
      },

      ActionTemp: function () {
        return {
          template: ActionTemp,
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        const remisHash = JSON.parse(localStorage.getItem("rHash"));
        if (!remisHash) {
          this.getRemisHash();
        } else {
          this.getCardRequests();
          this.getCards();
          this.getDashboardDetails();
        }
      }
    },
  },
  created() {
    this.secondTableData = [];
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });

    if (this.$route.query.companyId) {
      const remisHash = JSON.parse(localStorage.getItem("rHash"));
      if (!remisHash) {
        this.getRemisHash();
      } else {
        this.getCardRequests();
        this.getCards();
        this.getDashboardDetails();
      }
    }
    this.$eventHub.$on("companyRetainershipData", (data) => {
      this.details.data = data;
      this.details.queryStrings.id = data.id;
      this.details.queryStrings.walletId = data.walletId;
      this.details.queryStrings.name = data.firstName;

      const option = document.getElementById("myDropdown");
      option.classList.add("show");

      let index;

      if (data.index > 10 && parseInt(data.index.toString().slice(1)) === 0) {
        index = 10;
      }
      if (data.index > 10 && parseInt(data.index.toString().slice(1)) > 0) {
        index = parseInt(data.index.toString().slice(1));
      }

      if (data.index <= 10) {
        index = data.index;
      }

      option.style.top = `${(80 * index + (85 - index * 2)).toString()}px`;
    });

    this.$eventHub.$on("getCardRequests", () => {
      this.getCardRequests();
    });

    this.$eventHub.$on("approveCardRequest", () => {
      this.showApproveModal();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("getCardRequests");
    // this.$eventHub.$off("changeRetainership");
    // this.$eventHub.$off("setCreditLimit");
  },

  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    // Modal functions
    showFundWalletModal() {
      this.$modal.show("fund-wallet-payweall");
    },
    showAddRetainershipModal() {
      this.$modal.show("addRetainershipModal");
    },
    showAddNewRetainershipModal() {
      this.$modal.show("addNewRetainershipModal");
    },

    showApproveModal() {
      this.$modal.show("approvalRequestModal");
    },

    showAssignCardModal() {
      this.$modal.show("assignCardModal");
    },

    /////

    //Requests

    getRemisHash() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Account/RemisHash`,
          configObject.authConfig()
        )
        .then((response) => {
          localStorage.setItem("rHash", JSON.stringify(response.data));
          this.getCardRequests();
          this.getCards();
          this.getDashboardDetails();
        })
        .catch((error) => {});
    },

    getDashboardDetails() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Dashboard/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          this.totalCards = response.data.totalCard;
          this.availableCards = response.data.availableCards;
          this.pendingRequestNumber = response.data.pendingRequests;
          this.pendingNumberOfCardRequest = response.data.pendingRequestCards;
          this.approvedRequestNumber = response.data.approvedRequests;
          this.approvedNumberOfCardRequest = response.data.approvedRequestCards;

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          console.log(error);
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    //get number of cards
    getCards() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/Cards/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },

    getCardRequests() {
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/CardRequests/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,

          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          response.data.data.forEach((request) => {
            request.orderDate = this.$moment(request.orderDate).format(
              "YYYY/MM/DD"
            );
          });
          this.showLoader = false;

          let pendingRequest = response.data.data.filter(
            (el) => el.orderStatus.toLowerCase() === "pending"
          );

          let approvedRequest = response.data.data.filter(
            (el) => el.orderStatus.toLowerCase() === "fulfilled"
          );

          this.pendingRequest = pendingRequest;
          this.approvedRequest = approvedRequest;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: pendingRequest,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
          grid.ej2Instances.setProperties({ dataSource: [] });
          this.refreshGrid();

          console.log(error.response);
        });
    },

    //Utilities
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    changeTable(arg) {
      this.tableType = arg;
    },

    rowSelected(args) {
      //redirect to approval page
      this.$router.push({
        name: "approve-retainership-card-request",
        query: {
          companyId: this.$route.query.companyId,
          requestId: args.data.id,
        },
      });
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    changeRoute($newRoute, id, walletId, name) {
      this.$router.push({
        name: $newRoute,
        query: {
          id: id,
          walletId,
          name,
          companyId: this.$route.query.companyId,
        },
      });
    },

    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },
  },
};
</script>

<style scoped>
.overview-card {
  background-color: white;
  border: 1px solid #f3f4f5;
  color: #667085;
  border-radius: 10px;
  margin-bottom: 20px;
}

.overview-card h5 {
  font-size: 13px;
  text-transform: uppercase;
}

.overview-card p {
  font-weight: 700;
}
.e-grid .e-row:hover .e-rowcell {
  cursor: pointer;
  text-decoration: underline;
  color: purple;
}
@media screen and (max-width: 602px) {
  .addNewRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 150px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .addRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
